import React, { Component } from 'react';
import { Button } from 'antd';
import PackageFeatures from './PackageFeatures';
import { formatMoney } from '../../helpers';
import {CATEGORY_GA,eventGA } from  '../../Helpers/GoogleAnalytics';
import { Fragment } from 'react';

class PackageItem extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this)
        this.onClickEvent = this.onClickEvent.bind(this);
        this.getTypeButtons = this.getTypeButtons.bind(this);
        this.state = {
            value: 2,
        };
    }
    
    render() {
        let { data } = this.props;
        let { packageId, name, rfcLimit, yearlyPrice, description, features, isVisible, callToAction, isRecommended } = data;        
        let display = isVisible ? 'block' : 'none';
        return (
            <div className="package-item" style={{display}}>
                { isRecommended && <div className="recommended-tooltip small-text">Recomendado</div> }
                <div className="package-inner">
                    <h3 className="item-subtitle">{name}</h3>
                    <span className="description">{description} | <i style={{fontStyle:'normal'}} dangerouslySetInnerHTML={{__html: rfcLimit }}></i></span>
                    <div className="package-prices">
                        {   (yearlyPrice !== '0') &&
                            <Fragment>
                                <span className="radio-price">{formatMoney(yearlyPrice)}</span> <span className="radio-text"></span>
                                <span className="unlimited-yearly block">ANUAL IVA INCLUIDO</span>
                            </Fragment>
                        }
                    </div>
                    
                    {
                        <Button type="primary" className={`buy-license-button ${this.getTypeButtons(packageId)}`} onClick={this.onClickEvent} style={{marginTop:'15px', marginLeft:'20px'}}>
                            { callToAction }
                        </Button> 
                    }
                </div>
                <PackageFeatures features={features} />
                { name.toLowerCase() === 'corporativo' &&
                    <div className="advice-box">
                        <span className="label em">Próximamente</span>
                        <span className="small-text"><i className="blue-dot">•</i> Dashboard de indicadores del model de riesgos fiscales con Microsoft Power BI.  
                            <em className="block">(EFOS, facturas emitidas y recibidas, notas de crédito, nóminas percepciones gravadas y exentas, pagos emitidos y recibidos e impuestos).</em>
                        </span>
                        <span className="small-text"><i className="blue-dot">•</i> Integración con sistemas de facturación, nóminas o cualquier ERP]
                        </span>
                    </div>
                }
            </div>
   
        );
    }

    getTypeButtons(packageId) {
        let outlineButtonsIds = ['0','1','3'];        
        let found = outlineButtonsIds.includes(packageId.toString());
        return found  ? 'outline-button' : 'solid-button';
    }
    
	onChange(e) {
		this.setState({ value: e.target.value });
    };

    onClickEvent() {
           
        let packagesIdNotAllowToBuy = ['4'];
        if(this.props.onClick) {
            const { packageId } = this.props.data;
            if(packagesIdNotAllowToBuy.includes(packageId.toString()))
                window.open('https://sw.com.mx/sw_product/efisco/#form', '_blank')
            else
                this.props.onClick(this.props.data, this.getSelectedAmount());
        }
        eventGA(CATEGORY_GA.sales.purchaseStarted);
    }

    getSelectedAmount() {
        switch(this.state.value) {
            case 2:
                return this.props.data.yearlyPrice;
            default:
                return null;
        }
    }
}

export default PackageItem;